import AnchorLink from "react-anchor-link-smooth-scroll";
import * as React from 'react';
export default {
  AnchorLink,
  React
};